import React, { createElement } from "react";
import cn from "classnames";

import { SpriteIcon } from "@litres-libs/sprite-icons";

import type { IContextMenuItemProps } from "../types";

import styles from "./ContextMenu.module.scss";
import { Link } from "../../../link";
import { DiscountLabel } from "../../../discount-label";

const getCount = (num: number): string => {
  if (num > 99) {
    return "99+";
  }
  return num.toString();
};

export const ContextMenuItem = ({
  icon,
  onClick,
  text,
  asLink,
  href,
  counter,
  hasBadge,
  hasDiscount,
  className,
  ...restProps
}: IContextMenuItemProps) => {
  const content = createElement(
    asLink ? Link : "div",
    {
      href: href,
      className: cn(styles.contextMenu__item, className),
      onClick: e => {
        if (onClick) {
          e.stopPropagation();
          if (!asLink || !href) {
            e.preventDefault();
          }
          onClick();
        }
      },
      onKeyDown: asLink
        ? undefined
        : (e: React.KeyboardEvent) => {
            if (e.key === "Enter" || e.key === " ") {
              e.stopPropagation();
              if (!asLink || !href) {
                e.preventDefault();
              }
              onClick?.();
            }
          },
      role: "button",
      tabIndex: 0,
      "aria-label": text,
      ...restProps,
    },
    <>
      <div
        className={cn(styles.contextMenu__item__content, {
          [styles.promos]: hasBadge,
        })}
      >
        {icon && (
          <SpriteIcon {...icon} className={styles.contextMenu__item__icon} />
        )}
        {text}
      </div>
      {!!counter && <span className={styles.count}>{getCount(counter)}</span>}
      {hasDiscount && <DiscountLabel text="%" size="xxs" hasBorder={false} />}
    </>
  );

  return content;
};
